import React from 'react'
import Header from '../LandingPage/Header'
import Navbar from '../LandingPage/Navbar'
import Footer from '../LandingPage/Footer'
import QABox from './QABox'
import StepBox from './StepBox'
import SoftwareBox from './SoftwareBox'
import AboutPostHeader from '../ContactUs/AboutPostHeader'
const QA = () => {
  const service = [
    {
      head: 'Software Testing Services',
      para:
        'Quality Assurance to ensure high quality and reliability of software products using multitude of softwaretesting methods from unit testing to overall regressiontesting that maximize performance, enhance scalability and maintain top-notch quality of products.',
    },
    {
      head: 'QA Automation Services',
      para:
        'Expedite your quality assurance testing method by implementing a large set of functions that encompass test automation planning, tools analysis, maintenance and implementation of test scripts to accelerate overall test coverage with utmost quality.',
    },
  ]
  var serviceArray = service.map((section) => {
    return <QABox head={section.head} para={section.para} />
  })
  const softwareTesting = [
    {
      font: <i class="fas fa-3x text-primary fa-user-astronaut"></i>,
      head: 'Functional Testing',
      para:
        'Validating the software system to conform  each functional requirement of the application meets the expected output. Our experienced QA testing team implements functional testing to majorly focus on user interface, database, security, APIs, client or server application and similar functionalities of the application.',
    },
    {
      font: <i class="fas fa-3x text-primary fa-theater-masks"></i>,
      head: 'Performance Testing',
      para:
        'Increasing load time, inefficient responsiveness  and instability can be overcome by  performance testing. Our profound experience in performance testing by executing quality checks and software behaviour analysis under load and stress guarantees flawless, reliable  and smarter applications.',
    },
    {
        font: <i class="fas fa-3x text-primary fa-shield-alt"></i>,
        head: 'Security Testing',
        para:
          'Uncover potential vulnerabilities of your  running application by enabling security testing  with every release. Our software testing services are performed by a talented pool of  test engineers who execute risk assessment and penetration testing to shield applications from hackers or malicious threats',
    },
    {
        font: <i class="fas fa-3x text-primary fa-user-tag"></i>,
        head: 'Usability Testing',
        para:
          'Monitor application behaviour when multiple functions of the application operate concurrently. Our software testing services entail an in-depth analysis of user behaviour patterns that identify potential usability issues  in the initial phase and create a seamless product.',
    },
    {
        font: <i class="fas fa-3x text-primary fa-equals"></i>,
        head: 'Compatibility Testing',
        para:
          'Explore the possibilities of compatibility testing with TatvaSofts software testing services where an application is tested meticulously across different browsers, databases,  hardware, operating systems, server  infrastructures, resolution displays and  devices.',
    },
    {
        font: <i class="fas fa-3x text-primary fa-mobile"></i>,
        head: 'Mobile App Testing',
        para:
          'Scalability, security and multi-platform support are the cornerstones of a mobile app TatvaSoft provides cross platform functional/non-functional testing with manual as well as automated approach for diverse mobile applications',
    },
  ]
  var softwareTestingArray = softwareTesting.map((section) => {
    return <SoftwareBox font={section.font} head={section.head} para={section.para} />
  })
  const step = [
    {
      step:"01",
      para:"Ate automation expandability and blication scope."
    },
    {
        step:"02",
        para:"Define the automation scope and level to  employ"
      },
      {
        step:"03",
        para:"Tools selection and Automation architecture design"
      },
      {
        step:"04",
        para:"Automated test script and test data creation"
      },
      {
        step:"05",
        para:"Appropriate test evironment setup and configuration"
      },
      {
        step:"06",
        para:'Executing test automation script and data validation'
      },
      {
        step:"07",
        para:'Automated performance test for scalable backend'
      },

     
  ]
  var stepArray = step.map((section) => {
    return (
      <StepBox
        step={section.step}
        para={section.para}
      />
    )
  })
  const contact = {
    head: "   Software Testing",
    para: "  Our exclusive and top-notch quality assurance services include",
  };
  return (
    <div>
      <Header />
      <Navbar />
      <AboutPostHeader obj={contact} />

      <div className="container mt-5">
      
        <div className="row">{serviceArray}</div>
        <h2 className="font-weight-bold text-center text-primary mt-5">
          Software Testing & QA Services
        </h2>
        <div className="row">{softwareTestingArray}</div>
        <h2 className="font-weight-bold text-center text-primary mt-5">
         Our Test Automation Approach
        </h2>
        <div className='row'>
{stepArray}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default QA
